<!--
================================================
Vue affichant le formulaire de réinitialisation du mot de passe
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <outdoor-layout-comp>
        <div slot="AppContent">
            <!--Contenu à surcharger ici-->
            <password-reset-comp></password-reset-comp>
        </div>
    </outdoor-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import OutdoorLayoutComp from '@/components/OutdoorLayoutComp.vue'
    import PasswordResetComp from '@/components/PasswordResetComp.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";

    export default {
        name: 'PasswordResetView',
        components: {
            OutdoorLayoutComp,
            PasswordResetComp,
            // Component,
        },
        mixins: [VueMetaMixin],
        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleDefault"),this.$t("metaDescDefault"))
        },
        //==========================================================
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">


</style>
